<template>
  <div>
    <c-card title="교육교재" height="600px">
      <template slot="card-detail">
        <div class="col-12">
          <c-upload 
            :attachInfo="attachInfo"
            label="교육계획 관련 파일"
            :editable="editable&&!disabled">
          </c-upload>
        </div>
      </template>
      <template slot="card-detail">
        <div class="col-12">
          <c-upload 
            :attachInfo="attachInfo2"
            label="교육과정 관련 파일"
            :editable="false">
          </c-upload>
        </div>
      </template>
    </c-card>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: 'education-material',
  props: {
    param: {
      type: Object,
      default: () => ({
        eduEducationId: '',
      }),
    },
    tabParam: {
      type: Object,
      default: () => ({
        eduCourseId: '',
      }),
    },
  },
  data() {
    return {
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'EDU_PLAN',
        taskKey: '',
      },
      attachInfo2: {
        isSubmit: '',
        taskClassCd: 'EDU_CURRICULUM',
        taskKey: '',
      },
      editable: true,
      detailUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    }
  },
  computed: {
    disabled() {
      return Boolean(this.tabParam.documentStatusCd) && this.tabParam.documentStatusCd === 'ESC000010'
    },
  },
  watch: {
    'param.eduEducationId'() {
      this.setTaskKey();
    },
    'tabParam.eduCourseId'() {
      this.setTaskKey2();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      // list setting
      this.setTaskKey();
      this.setTaskKey2();
    },
    setTaskKey() {
      let taskKey = this.param.eduEducationId ? this.param.eduEducationId : '';
      this.attachInfo.taskKey = taskKey
    },
    setTaskKey2() {
      let taskKey = this.tabParam.eduCourseId ? this.tabParam.eduCourseId : '';
      this.attachInfo2.taskKey = taskKey
    },
  },
}
</script>
